import { notFound } from '@tanstack/react-router';

import { ApiError } from './api';

/**
 * API 가 404 를 주면 라우터의 notFound 로 바꾼다 (docs/SSR.md 「실패 시 동작」).
 *
 * 그래야 서버 응답 상태가 404 가 된다. 그냥 두면 loader 예외가 오류 화면으로 가면서
 * HTTP 500 이 나가, 삭제된 글이 크롤러에게 장애로 보인다.
 */
export async function orNotFound<T>(promise: Promise<T>): Promise<T> {
  try {
    return await promise;
  } catch (e) {
    if (e instanceof ApiError && e.status === 404) throw notFound();
    throw e;
  }
}
